export default {"src":"/_next/static/media/nodejs.e74119cc.svg","height":361,"width":590,"blurWidth":0,"blurHeight":0};